export var SAVE_ATTENDEE_TYPE_DATA = "SAVE_ATTENDEE_TYPE_DATA";
export var UPDATE_ATTENDEE_TYPE_STATUS = "UPDATE_ATTENDEE_TYPE_STATUS";
